import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HeaderBar from "./HeaderBar";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useCooldowns, useData } from "./MemberData";
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function CooldownsPage() {
    const { membersCooldowns, fetchCooldowns } = useCooldowns();
    const { getPoliceMemberInfo, getPenMemberInfo, policeMembersData } = useData();
    const [searchTerm, setSearchTerm] = useState("");
    const [myDiscordID, setMyDiscordID] = useState('');
    const [isHR, setHR] = useState(false);

    useEffect(() => {
        const idFromCookies = Cookies.get('myDiscordID') || '';
        setMyDiscordID(idFromCookies);
    }, []);

    useEffect(() => {
        let tempHR = false;
        for (let index = 0; index < policeMembersData.length; index++) {
            const element = policeMembersData[index];
            if (element.discordID === myDiscordID) {
                tempHR = true;
                break;
            }
        }

        setHR(tempHR);
    }, [myDiscordID, policeMembersData]);

    let filteredCooldowns = membersCooldowns
        .filter((cooldown) => {
            const searchLower = searchTerm.toLowerCase();
            return (
            String(cooldown.callsign).padStart(3, '0').includes(searchLower)
            );
        })
        .sort((a, b) => a.callsign - b.callsign); 

    const setPaid = async (callsign: number, type: string, cType: string) => {
        const result = await Swal.fire({
            title: `Ești sigur că vrei să plătești cooldown-ul?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });

                    
        if (!result.isConfirmed) {
            toast.error("Ai anulat acțiunea de plată cooldown!");
            return;
        } else {
            try {
                await makeAuthenticatedRequest(`${API_URL}/setCooldownPaid`, {
                    callsign,
                    type,
                    cType,
                    hrDiscordID: myDiscordID
                })
                toast.success("Plata a fost setată cu succes!");
                fetchCooldowns();
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare la setarea plății.");
                }
            }
        }
    }

    const deleteCooldown = async (callsign: number, type: string, cType: string) => {
        const result = await Swal.fire({
            title: `Ești sigur că vrei să ștergi cooldown-ul?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });

                    
        if (!result.isConfirmed) {
            toast.error("Ai anulat acțiunea de stergere cooldown!");
            return;
        } else {
            try {
                await makeAuthenticatedRequest(`${API_URL}/deleteCooldown`, {
                    callsign,
                    type,
                    cType,
                    hrDiscordID: myDiscordID
                })
                toast.success("Cooldown-ul a fost șters cu succes!");
                fetchCooldowns();
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare la stergerea cooldown-ului.");
                }
            }
        }
    }

    return (
        <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Listă Cooldown-uri" />
            <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                <div className="w-full h-[7%] flex items-center justify-between">
                    <div className="w-[30%] h-full flex items-center justify-between">
                        <span className="textSemiBold text-[1.1vw] text-[#ffffff]">Listă Cooldown-uri</span>
                    </div>          
                    <div className="bg-[#ffffff10] border border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
                        <input
                            type="text"
                            placeholder="Caută un polițist"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pb-[1%] text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
                        />
                        <FontAwesomeIcon className="text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
                    </div>
                </div>
                <div className="bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                    {Array.isArray(filteredCooldowns) && filteredCooldowns.length > 0 && (
                        filteredCooldowns.map((cooldown, index) => (
                        <div
                            key={index}
                            className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
                        >
                            <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {cooldown.type === "pol" ? getPoliceMemberInfo(cooldown.callsign, "user_id") : getPenMemberInfo(cooldown.callsign, "user_id")}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {cooldown.type === "pol" ? String(cooldown.callsign).padStart(3, '0') : `P-${String(cooldown.callsign).padStart(2, '0')}`}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {cooldown.cType}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[8%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {(() => {
                                    const rawDate = cooldown.start_date;
                                    const dateObj = typeof rawDate === "string" ? new Date(rawDate) : rawDate;

                                    const day = String(dateObj.getDate()).padStart(2, "0");
                                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                                    const year = dateObj.getFullYear();

                                    return `${day}.${month}.${year}`;
                                })()}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {(() => {
                                    const start = typeof cooldown.start_date === "string"
                                    ? new Date(cooldown.start_date)
                                    : cooldown.start_date;

                                    const expiration = new Date(start);
                                    expiration.setDate(expiration.getDate() + cooldown.days);

                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    expiration.setHours(0, 0, 0, 0);

                                    const diffInMs = expiration.getTime() - today.getTime();
                                    const remainingDays = Math.max(Math.ceil(diffInMs / (1000 * 60 * 60 * 24)), 0);

                                    return remainingDays;
                                })()}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {cooldown.confiscated ? "DA" : "NU"}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {(() => {
                                    const start = typeof cooldown.start_date === "string"
                                    ? new Date(cooldown.start_date)
                                    : cooldown.start_date;

                                    const expiration = new Date(start);
                                    expiration.setDate(expiration.getDate() + cooldown.days);

                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    expiration.setHours(0, 0, 0, 0);

                                    const diffInMs = expiration.getTime() - today.getTime();
                                    const remainingDays = Math.max(Math.ceil(diffInMs / (1000 * 60 * 60 * 24)), 0);
                                    if (cooldown.confiscated) {
                                        return (Number(remainingDays)*50000).toLocaleString("gb-GB");
                                    } else {
                                        return (Number(remainingDays)*25000).toLocaleString("gb-GB");
                                    }
                                })()}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            {(cooldown.paid_status && isHR) ? (
                                <div className="w-[7%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer">
                                    <span className="textBold text-[#1eb80d] text-[.7vw]">PLĂTIT</span>
                                </div>
                            ) : (
                                <div onClick={() => setPaid(cooldown.callsign, cooldown.type, cooldown.cType)} className="w-[7%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#1eb80d] to-[#26e810]">
                                    <span className="textBold text-white text-[.7vw]">PLĂTEȘTE</span>
                                </div>
                            )}
                            {isHR && (
                                <>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <div onClick={() => deleteCooldown(cooldown.callsign, cooldown.type, cooldown.cType)} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#b80d0d] to-[#e81010]">
                                        <span className="textBold text-white text-[.7vw]">ȘTERGE</span>
                                    </div>
                                </>
                            )}
                        </div>
                    )))}
                </div>
            </div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
    );
}

export default CooldownsPage;